// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.section.dark-theme[data-v-2ae3038e]{background-color:var(--bg-secondary);padding-top:9.6rem}@media (max-width:767px){.section.dark-theme[data-v-2ae3038e]{padding-top:6.4rem}}.section.--new-style[data-v-2ae3038e]{padding:9.6rem 0 4.8rem}@media (max-width:767px){.section.--new-style[data-v-2ae3038e]{padding:6.4rem 1.6rem 3.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
